module.exports = __webpack_public_path__ + "img/banner.89a0b02b.jpg";